import styled from 'styled-components'

export const StyledNewsRemoveBookmarkButton = styled.div`
  button {
    width: 24px;
    height: 24px;
    border-radius: 6px;
  }
`
